import { lazy } from "react";

export const InviteFriendAsync = lazy(() => import("./InviteFriend"));
